@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Inter:wght@300;400;500;600;700&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --font-heading: 'Playfair Display', Georgia, serif;
  --font-body: 'Inter', system-ui, sans-serif;

  --background-50: 1 0 0;
  --background-100: 0.98 0.01 250;
  --background-200: 0.912 0.01 228;
  --background-300: 0.85 0.02 250;
  --background-400: 0.78 0.03 250;
  --background-500: 0.70 0.04 250;
  --background-600: 0.60 0.05 250;
  --background-700: 0.50 0.06 250;
  --background-800: 0.40 0.07 250;
  --background-900: 0.30 0.08 250;
  --background-950: 0.20 0.09 250;

  --primary-50: 0.96 0.01 250;
  --primary-100: 0.92 0.02 250;
  --primary-200: 0.85 0.03 250;
  --primary-300: 0.72 0.05 250;
  --primary-400: 0.48 0.08 250;
  --primary-500: 0.245 0.09 249;
  --primary-600: 0.20 0.08 250;
  --primary-700: 0.16 0.07 250;
  --primary-800: 0.12 0.06 250;
  --primary-900: 0.08 0.04 250;
  --primary-950: 0.04 0.02 250;

  --secondary-50: 0.96 0.02 165;
  --secondary-100: 0.92 0.03 165;
  --secondary-200: 0.85 0.04 165;
  --secondary-300: 0.72 0.06 165;
  --secondary-400: 0.65 0.10 165;
  --secondary-500: 0.578 0.12 164;
  --secondary-600: 0.50 0.11 165;
  --secondary-700: 0.42 0.10 165;
  --secondary-800: 0.35 0.09 165;
  --secondary-900: 0.25 0.07 165;
  --secondary-950: 0.15 0.05 165;

  --accent-50: 0.96 0.02 290;
  --accent-100: 0.92 0.03 290;
  --accent-200: 0.85 0.04 290;
  --accent-300: 0.72 0.06 290;
  --accent-400: 0.60 0.10 290;
  --accent-500: 0.509 0.13 290;
  --accent-600: 0.45 0.12 290;
  --accent-700: 0.38 0.11 290;
  --accent-800: 0.30 0.09 290;
  --accent-900: 0.20 0.07 290;
  --accent-950: 0.12 0.05 290;

  --foreground-50: 0.95 0.01 250;
  --foreground-100: 0.90 0.02 250;
  --foreground-200: 0.80 0.03 250;
  --foreground-300: 0.65 0.04 250;
  --foreground-400: 0.50 0.05 250;
  --foreground-500: 0.40 0.06 250;
  --foreground-600: 0.30 0.07 250;
  --foreground-700: 0.25 0.08 250;
  --foreground-800: 0.18 0.09 250;
  --foreground-900: 0.12 0.10 250;
  --foreground-950: 0.08 0.11 250;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-body), system-ui, sans-serif;
}

@layer utilities {
  .text-shadow-soft {
    text-shadow: 0 1px 3px rgba(7, 20, 40, 0.55), 0 2px 8px rgba(7, 20, 40, 0.35);
  }
  .gradient-brand {
    background: linear-gradient(135deg, #072D5A, #295687, #368B73);
  }
  .gradient-brand-horizontal {
    background: linear-gradient(to right, #072D5A, #295687, #368B73);
  }
  .gradient-brand-top {
    background: linear-gradient(to bottom, #072D5A, #295687, #368B73);
  }
  .text-gradient-brand {
    background: linear-gradient(135deg, #072D5A, #295687, #368B73);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
}